import { getRem } from 'lib/core';
import styled from 'styled-components';

import { ChipDatePickerContainerBase } from './ChipDatePickerContainerBase';

export const ChipDateRangePickerContainer = styled(ChipDatePickerContainerBase)`
  display: flex;
  max-width: ${getRem(300)};
  position: relative;
`;
